import { API_METHODS } from './api.enums';
import { apiAction } from './utils.actions';

export const importExternalJobs = (
    { userid }: { userid: number },
) => apiAction({
    url: `/import/external-jobs/${userid}`,
    method: API_METHODS.GET,
});
